import { Card } from "@dropbox/dash-component-library";
import { IconButton } from "@dropbox/dig-components/buttons";
import { Menu } from "@dropbox/dig-components/menu";
import { Box } from "@dropbox/dig-foundations";
import { UIIcon } from "@dropbox/dig-icons";
import { HideLine, MoreHorizontalLine } from "@dropbox/dig-icons/assets";
import i18n from "@mirage/translations";
import React, { ComponentType, SVGAttributes } from "react";
import styles from "./ModuleItemContainer.module.css";

interface Props {
  children?: React.ReactNode;
  label: string;
  leftAccessory: ComponentType<SVGAttributes<SVGElement>>;
  onHideClick: (value: string) => void;
  "data-testid"?: string;
}

export const ModuleItemContainer = ({
  children,
  label,
  leftAccessory,
  onHideClick,
  "data-testid": dataTestId,
}: Props) => {
  return (
    <div data-testid={dataTestId}>
      <Card.Module>
        <Box display="flex" alignItems="flex-start">
          <Box marginBottom="Micro Small">
            <UIIcon src={leftAccessory} className={styles.leftIcon} />
          </Box>
          <Box flexGrow={1}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <Card.Header title={label} />
              <Box>
                <Menu.Wrapper onSelection={onHideClick}>
                  {({ getTriggerProps, getContentProps }) => (
                    <>
                      <IconButton
                        {...getTriggerProps()}
                        variant="transparent"
                        aria-label={i18n.t("setup_module_menu_title")}
                        data-testid="setup-module-menu"
                      >
                        <UIIcon
                          color="var(--dig-color__text__subtle)"
                          src={MoreHorizontalLine}
                        />
                      </IconButton>
                      <Menu.Content
                        {...getContentProps()}
                        positioningStrategy="fixed"
                        placement="bottom-end"
                      >
                        <Menu.Segment>
                          <Menu.ActionItem value={"hide"} key={"hide"}>
                            <Box
                              display="flex"
                              alignItems="center"
                              className={styles.menuItem}
                            >
                              <UIIcon src={HideLine} />
                              <span>{i18n.t("setup_module_hide")}</span>
                            </Box>
                          </Menu.ActionItem>
                        </Menu.Segment>
                      </Menu.Content>
                    </>
                  )}
                </Menu.Wrapper>
              </Box>
            </Box>
            <Box paddingLeft="Macro Small" paddingTop="Micro XSmall">
              {children}
            </Box>
          </Box>
        </Box>
      </Card.Module>
    </div>
  );
};
